import { PjmRegistrationLeadTime, PjmRegistrationProgram, PjmRegistrationStatus } from 'src/domain/pjm/dto/enums';
import { FormInstance } from 'antd/lib/form';
import { PjmRegistrationDto } from 'src/domain/pjm/dto/PjmRegistrationDto';
import dayjs from 'dayjs';
import { getDefaultRegistrationDates } from 'src/domain/pjm/validators';
import { PJM_TZ } from '../../../../../domain/pjm';

export const defaultFormState = {
    /** bellow 3 fields state are not goi9nhg to change */
    locationUuid: { state: 'hidden' },
    uuid: { state: 'hidden' },
    id: { state: 'disabled' },

    'summaryInfo.name': { state: 'hidden' },
    'summaryInfo.program': { state: 'hidden' },
    'summaryInfo.startDate': { state: 'hidden' },
    'summaryInfo.endDate': { state: 'hidden' },
    'summaryInfo.CSP.name': { state: 'hidden' },
    'summaryInfo.CSP.accountNo': { state: 'hidden' },
    'summaryInfo.EDC.name': { state: 'hidden' },
    'summaryInfo.EDC.accountNo': { state: 'hidden' },
    'summaryInfo.LSE.name': { state: 'hidden' },
    'summaryInfo.zone': { state: 'hidden' },
    'summaryInfo.pricingPoint': { state: 'hidden' },
    'summaryInfo.status': { state: 'hidden' },
    'summaryInfo.dispatchGroup': { state: 'hidden' },
    'summaryInfo.completed': { state: 'hidden', value: false },
    'summaryInfo.testRequired': { state: 'hidden', value: false },
    'summaryInfo.residential': { state: 'hidden' },
    'summaryInfo.residentialProgramType': { state: 'hidden' },
    'summaryInfo.loadDataSample': { state: 'hidden' },
    'summaryInfo.sampleNumberParticipants': { state: 'hidden' },
    'summaryInfo.underDuplicateReview': { state: 'hidden' },

    'locationSummaryInfo.energyLossFactor': { state: 'hidden' },
    'locationSummaryInfo.capacityLossFactor': { state: 'hidden' },
    'locationSummaryInfo.peakLoadContribution': { state: 'hidden' },
    'locationSummaryInfo.winterPeakLoad': { state: 'hidden' },
    'locationSummaryInfo.maximumLoadReductionCapability': { state: 'hidden' },

    // locationInfo - ignore for now

    'energyInfo.loadReduction': { state: 'hidden' },
    'energyInfo.energyLossFactor': { state: 'hidden' },
    'energyInfo.strikePrice': { state: 'hidden' },
    'energyInfo.shutdownCosts': { state: 'hidden' },
    'energyInfo.contractType': { state: 'hidden' },
    'energyInfo.priceNode': { state: 'hidden' },
    'energyInfo.retailRate': { state: 'hidden' },
    'energyInfo.rateName': { state: 'hidden' },
    'energyInfo.rateDescription': { state: 'hidden' },
    'energyInfo.dayAhead': { state: 'hidden' },
    'energyInfo.realTime': { state: 'hidden' },
    'energyInfo.scheduledReserve': { state: 'hidden' },
    'energyInfo.secondaryReserve': { state: 'hidden' },
    'energyInfo.synchronizedReserve': { state: 'hidden' },
    'energyInfo.flexible': { state: 'hidden' },
    'energyInfo.inflexible': { state: 'hidden' },
    'energyInfo.regulation': { state: 'hidden' },
    'energyInfo.batchLoad': { state: 'hidden' },
    'energyInfo.secrArea': { state: 'hidden' },
    'energyInfo.secrSCADATestedAndVerified': { state: 'hidden' },
    'energyInfo.srArea': { state: 'hidden' },
    'energyInfo.srSCADATestedAndVerified': { state: 'hidden' },
    'energyInfo.regulationSCADAName': { state: 'hidden' },
    'energyInfo.regulationSCADATestedAndVerified': { state: 'hidden' },
    'energyInfo.regulationTestCompleted': { state: 'hidden' },
    'energyInfo.submeter': { state: 'hidden' },
    'energyInfo.regulationCertify': { state: 'hidden' },

    'capacityInfo.capacityType': { state: 'hidden' },
    'capacityInfo.zoneArea': { state: 'hidden' },
    'capacityInfo.RPMResourceID': { state: 'hidden' },
    'capacityInfo.measurementMethod': { state: 'hidden' },
    'capacityInfo.capacityLossFactor': { state: 'hidden' },
    'capacityInfo.peakLoadContribution': { state: 'hidden' },
    'capacityInfo.winterPeakLoad': { state: 'hidden' },
    'capacityInfo.summerManagedLoad': { state: 'hidden' },
    'capacityInfo.winterManagedLoad': { state: 'hidden' },
    'capacityInfo.summerWeatherAdjustmentFactor': { state: 'hidden' },
    'capacityInfo.winterWeatherAdjustmentFactor': { state: 'hidden' },
    'capacityInfo.participantCount': { state: 'hidden' },
    'capacityInfo.summerNominatedICAP': { state: 'hidden' },
    'capacityInfo.winterNominatedICAP': { state: 'hidden' },
    'capacityInfo.annualNominatedICAP': { state: 'hidden' },
    'capacityInfo.product': { state: 'hidden' },
    'capacityInfo.resourceType': { state: 'hidden' },
    'capacityInfo.leadTime': { state: 'hidden' },
    'capacityInfo.leadExceptionReason': { state: 'hidden' },
    'capacityInfo.leadExceptionDesc': { state: 'hidden' },
    'capacityInfo.leadExceptionCertify': { state: 'hidden' },
    'capacityInfo.summerOnly': { state: 'hidden' },

    'cblMethodInfo.methodName': { state: 'hidden' },

    'priceResponsiveDemandInfo.dynamicRetailRate': { state: 'hidden' },
    'priceResponsiveDemandInfo.scadaAvailable': { state: 'hidden' },

    'generatorCostInfo.retailRateType': { state: 'hidden' },
    'generatorCostInfo.delivery': { state: 'hidden' },
    'generatorCostInfo.supply': { state: 'hidden' },
    'generatorCostInfo.fuelCost': { state: 'hidden' },
    'generatorCostInfo.variableOm': { state: 'hidden' },

    'regCblParameters.weatherStationName': { state: 'hidden' },
    'regCblParameters.regCblParameter': { state: 'hidden' },

    'otherInfo.allowEDCtoModify': { state: 'hidden' },
    'otherInfo.allowLSEtoModify': { state: 'hidden' },
    'otherInfo.holdScheduling': { state: 'hidden' },
    'otherInfo.holdSettlements': { state: 'hidden' },
    'otherInfo.comment': { state: 'hidden' },

    peakShavingProgram: { state: 'hidden' },
    comments: { state: 'hidden' },

    energySection: { state: 'hidden' },
    priceResponsiveDemandSection: { state: 'hidden' },
    marketsSection: { state: 'hidden' },
    capacitySection: { state: 'hidden' },
    capacityPrdSection: { state: 'hidden' }, // limited set of fields for Price Responsive Demand program

    synchronizedReserveSection: { state: 'hidden' },
    secondaryReserveSection: { state: 'hidden' },
    regulationSection: { state: 'hidden' },
} as const;

export type PjmRegistrationFormState = Record<
    keyof typeof defaultFormState,
    {
        state: 'hidden' | 'disabled' | 'editable';
        value?: string | number | boolean | null;
    }
>;

type ChangeFormAction = {
    type: 'CHANGE';
    payload: FormInstance<PjmRegistrationDto>;
};

type ChangeProgramAction = {
    type: 'CHANGE_PROGRAM';
    payload: FormInstance<PjmRegistrationDto>;
};

type ChangeStatusAction = {
    type: 'CHANGE_STATUS';
    payload: FormInstance<PjmRegistrationDto>;
};

type PjmRegistrationFormStateAction = ChangeFormAction | ChangeProgramAction | ChangeStatusAction;

export function reducer(state: PjmRegistrationFormState, action: PjmRegistrationFormStateAction): PjmRegistrationFormState {
    switch (action.type) {
        case 'CHANGE':
        case 'CHANGE_PROGRAM':
        case 'CHANGE_STATUS':
            let newState = deriveFromStateForProgram(state, action.payload);
            newState = deriveFromStateForStatus(newState, action.payload);
            return { ...newState };
        default:
            return state;
    }
}

function deriveFromStateForProgram(state: PjmRegistrationFormState, form: FormInstance<PjmRegistrationDto>): PjmRegistrationFormState {
    const program = form.getFieldValue(['summaryInfo', 'program']);

    /** if registration has uuid - means it has been saved */
    const isSaved = !!form.getFieldValue(['uuid']);

    /** reset everything to default state (hidden) */
    Object.values(state).map(item => {
        item.state = 'hidden';
        return item;
    });

    switch (program) {
        case PjmRegistrationProgram.Economic: {
            const showLse =
                form.getFieldValue(['energyInfo', 'realTime']) ||
                form.getFieldValue(['energyInfo', 'dayAhead']) ||
                form.getFieldValue(['energyInfo', 'inflexible']);

            const isSynchronizedReserveChecked = form.getFieldValue(['energyInfo', 'synchronizedReserve']);
            const isSecondaryReserveChecked = form.getFieldValue(['energyInfo', 'secondaryReserve']);
            const isAnyReserveChecked = isSynchronizedReserveChecked || isSecondaryReserveChecked;
            const isRegulatedChecked = form.getFieldValue(['energyInfo', 'regulation']);
            const isRegulatedSubmeterChecked = form.getFieldValue(['energyInfo', 'submeter']);
            const isFlexibleChecked = form.getFieldValue(['energyInfo', 'flexible']);
            const isResidentialChecked = form.getFieldValue(['summaryInfo', 'residential']);

            // Dates editable: Effective -> Today + 2 days (12/06/2025); Termination -> 01/10/2027 (+400 days from start)
            // if record is new - changing program should reset dates to default
            // if record was saved - we should display saved values
            if (!isSaved) {
                const { startDate, endDate } = getDefaultRegistrationDates(program);

                const _startDate = form.getFieldValue(['summaryInfo', 'startDate'])
                    ? form.getFieldValue(['summaryInfo', 'startDate'])
                    : dayjs(startDate).tz(PJM_TZ);

                const _endDate = form.getFieldValue(['summaryInfo', 'endDate'])
                    ? form.getFieldValue(['summaryInfo', 'endDate'])
                    : dayjs(endDate).tz(PJM_TZ);

                form.setFieldValue(['summaryInfo', 'startDate'], _startDate);
                form.setFieldValue(['summaryInfo', 'endDate'], _endDate);

                form.setFieldValue(['summaryInfo', 'testRequired'], false);
                form.setFieldValue(['summaryInfo', 'completed'], false);
            }

            state['summaryInfo.name'] = { state: 'editable' };
            state['summaryInfo.program'] = { state: 'editable' };
            state['summaryInfo.startDate'] = { state: 'editable' };
            state['summaryInfo.endDate'] = { state: 'editable' };
            state['summaryInfo.CSP.name'] = { state: 'disabled' };
            state['summaryInfo.CSP.accountNo'] = { state: 'disabled' };
            state['summaryInfo.EDC.name'] = { state: 'disabled' };
            state['summaryInfo.EDC.accountNo'] = { state: 'disabled' };
            state['summaryInfo.LSE.name'] = { state: showLse ? 'editable' : 'hidden' };
            state['summaryInfo.zone'] = { state: 'disabled' };
            state['summaryInfo.pricingPoint'] = { state: 'disabled' };
            state['summaryInfo.status'] = { state: 'disabled' };
            state['summaryInfo.residential'] = { state: 'editable' };
            state['summaryInfo.residentialProgramType'] = { state: isResidentialChecked ? 'editable' : 'hidden' };
            state['summaryInfo.loadDataSample'] = { state: isResidentialChecked ? 'editable' : 'hidden' };
            state['summaryInfo.sampleNumberParticipants'] = { state: isResidentialChecked ? 'editable' : 'hidden' };

            state['locationSummaryInfo.energyLossFactor'] = { state: 'disabled' };
            state['locationSummaryInfo.maximumLoadReductionCapability'] = { state: 'disabled' };

            state['energyInfo.dayAhead'] = { state: 'editable' };
            state['energyInfo.realTime'] = { state: 'editable' };
            state['energyInfo.scheduledReserve'] = { state: 'editable' };
            state['energyInfo.secondaryReserve'] = { state: 'editable' };
            state['energyInfo.synchronizedReserve'] = { state: 'editable' };
            state['energyInfo.flexible'] = { state: isAnyReserveChecked ? 'editable' : 'hidden' };
            state['energyInfo.inflexible'] = { state: isAnyReserveChecked ? 'editable' : 'hidden' };
            state['energyInfo.regulation'] = { state: 'editable' };
            state['energyInfo.batchLoad'] = { state: isAnyReserveChecked ? 'editable' : 'hidden' };
            state['energyInfo.secrArea'] = { state: 'disabled' };
            state['energyInfo.secrSCADATestedAndVerified'] = { state: isFlexibleChecked ? 'editable' : 'hidden' };
            state['energyInfo.srArea'] = { state: 'disabled' };
            state['energyInfo.srSCADATestedAndVerified'] = { state: isFlexibleChecked ? 'editable' : 'hidden' };
            state['energyInfo.regulationSCADAName'] = { state: 'editable' };
            state['energyInfo.regulationSCADATestedAndVerified'] = { state: 'editable' };
            state['energyInfo.regulationTestCompleted'] = { state: 'editable' };
            state['energyInfo.submeter'] = { state: 'editable' };
            state['energyInfo.regulationCertify'] = { state: isRegulatedSubmeterChecked ? 'editable' : 'hidden' };

            state['otherInfo.allowEDCtoModify'] = { state: 'editable' };
            state['otherInfo.allowLSEtoModify'] = { state: 'editable' };
            state['otherInfo.holdScheduling'] = { state: 'disabled' };
            state['otherInfo.holdSettlements'] = { state: 'disabled' };

            state['marketsSection'] = { state: 'editable' };
            state['synchronizedReserveSection'] = { state: isSynchronizedReserveChecked ? 'editable' : 'hidden' };
            state['secondaryReserveSection'] = { state: isSecondaryReserveChecked ? 'editable' : 'hidden' };
            state['regulationSection'] = { state: isRegulatedChecked ? 'editable' : 'hidden' };
            state['comments'] = { state: 'editable' };

            break;
        }
        case PjmRegistrationProgram['Load Management DR Full']: {
            // Dates hardcoded: Effective -> 06/01/2026; Termination -> 05/31/2027
            if (!isSaved) {
                const { startDate, endDate } = getDefaultRegistrationDates(program);

                form.setFieldValue(['summaryInfo', 'startDate'], dayjs.utc(startDate));
                form.setFieldValue(['summaryInfo', 'endDate'], dayjs.utc(endDate));

                form.setFieldValue(['summaryInfo', 'testRequired'], true);
                form.setFieldValue(['summaryInfo', 'completed'], false);
            }

            if (!form.getFieldValue(['capacityInfo', 'leadTime'])) {
                form.setFieldValue(['capacityInfo', 'leadTime'], PjmRegistrationLeadTime.Quick_30);
            }

            const isResidentialChecked = form.getFieldValue(['summaryInfo', 'residential']);
            const showLeadTimeException = [PjmRegistrationLeadTime.Short_60, PjmRegistrationLeadTime.Long_120].includes(
                form.getFieldValue(['capacityInfo', 'leadTime'])
            );

            state['summaryInfo.name'] = { state: 'editable' };
            state['summaryInfo.program'] = { state: isSaved ? 'disabled' : 'editable' };
            state['summaryInfo.startDate'] = { state: 'disabled' };
            state['summaryInfo.endDate'] = { state: 'disabled' };
            state['summaryInfo.CSP.name'] = { state: 'disabled' };
            state['summaryInfo.CSP.accountNo'] = { state: 'hidden' };
            state['summaryInfo.EDC.name'] = { state: 'disabled' };
            state['summaryInfo.EDC.accountNo'] = { state: 'hidden' };
            state['summaryInfo.LSE.name'] = { state: 'hidden' };
            state['summaryInfo.zone'] = { state: 'disabled' };
            state['summaryInfo.pricingPoint'] = { state: 'disabled' };
            state['summaryInfo.status'] = { state: 'disabled' };
            state['summaryInfo.dispatchGroup'] = { state: 'hidden' };
            state['summaryInfo.completed'] = { state: 'disabled' };
            state['summaryInfo.testRequired'] = { state: 'disabled' };
            state['summaryInfo.residential'] = { state: 'editable' };
            state['summaryInfo.residentialProgramType'] = { state: isResidentialChecked ? 'editable' : 'hidden' };
            state['summaryInfo.loadDataSample'] = { state: isResidentialChecked ? 'editable' : 'hidden' };
            state['summaryInfo.sampleNumberParticipants'] = { state: isResidentialChecked ? 'editable' : 'hidden' };
            state['summaryInfo.underDuplicateReview'] = { state: 'hidden' };

            state['locationSummaryInfo.energyLossFactor'] = { state: 'disabled' };
            state['locationSummaryInfo.capacityLossFactor'] = { state: 'disabled' };
            state['locationSummaryInfo.peakLoadContribution'] = { state: 'disabled' };
            state['locationSummaryInfo.winterPeakLoad'] = { state: 'disabled' };
            state['locationSummaryInfo.maximumLoadReductionCapability'] = { state: 'disabled' };

            state['energyInfo.strikePrice'] = { state: 'editable' };
            state['energyInfo.shutdownCosts'] = { state: 'editable' };

            state['capacityInfo.capacityType'] = { state: 'hidden' };
            state['capacityInfo.zoneArea'] = { state: 'hidden' };
            state['capacityInfo.RPMResourceID'] = { state: 'editable' };
            state['capacityInfo.measurementMethod'] = { state: 'editable' };
            state['capacityInfo.capacityLossFactor'] = { state: 'disabled' };
            state['capacityInfo.peakLoadContribution'] = { state: 'disabled' };
            state['capacityInfo.winterPeakLoad'] = { state: 'disabled' };
            state['capacityInfo.summerManagedLoad'] = { state: 'editable' };
            state['capacityInfo.winterManagedLoad'] = { state: 'editable' };
            state['capacityInfo.summerWeatherAdjustmentFactor'] = { state: 'disabled' };
            state['capacityInfo.winterWeatherAdjustmentFactor'] = { state: 'disabled' };
            state['capacityInfo.participantCount'] = { state: 'hidden' };
            state['capacityInfo.summerNominatedICAP'] = { state: 'disabled' };
            state['capacityInfo.winterNominatedICAP'] = { state: 'disabled' };
            state['capacityInfo.annualNominatedICAP'] = { state: 'hidden' };
            state['capacityInfo.product'] = { state: 'editable' };
            state['capacityInfo.resourceType'] = { state: 'editable' };
            state['capacityInfo.leadTime'] = { state: 'editable' };
            state['capacityInfo.leadExceptionReason'] = { state: showLeadTimeException ? 'editable' : 'hidden' };
            state['capacityInfo.leadExceptionDesc'] = { state: showLeadTimeException ? 'editable' : 'hidden' };
            state['capacityInfo.leadExceptionCertify'] = { state: showLeadTimeException ? 'editable' : 'hidden' };
            state['capacityInfo.summerOnly'] = { state: 'editable' };

            state['cblMethodInfo.methodName'] = { state: 'hidden' }; // disabled?

            state['otherInfo.allowEDCtoModify'] = { state: 'editable' };
            state['otherInfo.allowLSEtoModify'] = { state: 'editable' };
            state['otherInfo.holdScheduling'] = { state: 'hidden' };
            state['otherInfo.holdSettlements'] = { state: 'hidden' };
            state['otherInfo.comment'] = { state: 'hidden' };

            state['energySection'] = { state: 'editable' };
            state['capacitySection'] = { state: 'editable' };
            state['comments'] = { state: 'editable' };

            break;
        }
        case PjmRegistrationProgram['Load Management DR Capacity Only']: {
            // Dates hardcoded: Effective -> 06/01/2026; Termination -> 05/31/2027
            if (!isSaved) {
                const { startDate, endDate } = getDefaultRegistrationDates(program);

                form.setFieldValue(['summaryInfo', 'startDate'], dayjs(startDate).tz(PJM_TZ));
                form.setFieldValue(['summaryInfo', 'endDate'], dayjs(endDate).tz(PJM_TZ));

                form.setFieldValue(['summaryInfo', 'testRequired'], true);
                form.setFieldValue(['summaryInfo', 'completed'], false);
            }

            if (!form.getFieldValue(['capacityInfo', 'leadTime'])) {
                form.setFieldValue(['capacityInfo', 'leadTime'], PjmRegistrationLeadTime.Quick_30);
            }

            const isResidentialChecked = form.getFieldValue(['summaryInfo', 'residential']);
            const showLeadTimeException = [PjmRegistrationLeadTime.Short_60, PjmRegistrationLeadTime.Long_120].includes(
                form.getFieldValue(['capacityInfo', 'leadTime'])
            );

            state['summaryInfo.name'] = { state: 'editable' };
            state['summaryInfo.program'] = { state: isSaved ? 'disabled' : 'editable' };
            state['summaryInfo.startDate'] = { state: 'disabled' };
            state['summaryInfo.endDate'] = { state: 'disabled' };
            state['summaryInfo.CSP.name'] = { state: 'disabled' };
            state['summaryInfo.CSP.accountNo'] = { state: 'hidden' };
            state['summaryInfo.EDC.name'] = { state: 'disabled' };
            state['summaryInfo.EDC.accountNo'] = { state: 'hidden' };
            state['summaryInfo.LSE.name'] = { state: 'hidden' };
            state['summaryInfo.zone'] = { state: 'disabled' };
            state['summaryInfo.pricingPoint'] = { state: 'disabled' };
            state['summaryInfo.status'] = { state: 'disabled' };
            state['summaryInfo.dispatchGroup'] = { state: 'hidden' };
            state['summaryInfo.completed'] = { state: 'disabled' };
            state['summaryInfo.testRequired'] = { state: 'disabled' };
            state['summaryInfo.residential'] = { state: 'editable' };
            state['summaryInfo.residentialProgramType'] = { state: isResidentialChecked ? 'editable' : 'hidden' };
            state['summaryInfo.loadDataSample'] = { state: isResidentialChecked ? 'editable' : 'hidden' };
            state['summaryInfo.sampleNumberParticipants'] = { state: isResidentialChecked ? 'editable' : 'hidden' };
            state['summaryInfo.underDuplicateReview'] = { state: 'hidden' };

            state['locationSummaryInfo.energyLossFactor'] = { state: 'hidden' };
            state['locationSummaryInfo.capacityLossFactor'] = { state: 'disabled' };
            state['locationSummaryInfo.peakLoadContribution'] = { state: 'disabled' };
            state['locationSummaryInfo.winterPeakLoad'] = { state: 'disabled' };
            state['locationSummaryInfo.maximumLoadReductionCapability'] = { state: 'disabled' };

            state['energyInfo.strikePrice'] = { state: 'hidden' };
            state['energyInfo.shutdownCosts'] = { state: 'hidden' };

            state['capacityInfo.capacityType'] = { state: 'hidden' };
            state['capacityInfo.zoneArea'] = { state: 'hidden' };
            state['capacityInfo.RPMResourceID'] = { state: 'editable' };
            state['capacityInfo.measurementMethod'] = { state: 'editable' };
            state['capacityInfo.capacityLossFactor'] = { state: 'disabled' };
            state['capacityInfo.peakLoadContribution'] = { state: 'disabled' };
            state['capacityInfo.winterPeakLoad'] = { state: 'disabled' };
            state['capacityInfo.summerManagedLoad'] = { state: 'editable' };
            state['capacityInfo.winterManagedLoad'] = { state: 'editable' };
            state['capacityInfo.summerWeatherAdjustmentFactor'] = { state: 'disabled' };
            state['capacityInfo.winterWeatherAdjustmentFactor'] = { state: 'disabled' };
            state['capacityInfo.participantCount'] = { state: 'hidden' };
            state['capacityInfo.summerNominatedICAP'] = { state: 'disabled' };
            state['capacityInfo.winterNominatedICAP'] = { state: 'disabled' };
            state['capacityInfo.annualNominatedICAP'] = { state: 'hidden' };
            state['capacityInfo.product'] = { state: 'editable' };
            state['capacityInfo.resourceType'] = { state: 'editable' };
            state['capacityInfo.leadTime'] = { state: 'editable' };
            state['capacityInfo.leadExceptionReason'] = { state: showLeadTimeException ? 'editable' : 'hidden' };
            state['capacityInfo.leadExceptionDesc'] = { state: showLeadTimeException ? 'editable' : 'hidden' };
            state['capacityInfo.leadExceptionCertify'] = { state: showLeadTimeException ? 'editable' : 'hidden' };
            state['capacityInfo.summerOnly'] = { state: 'editable' };

            state['cblMethodInfo.methodName'] = { state: 'hidden' }; // disabled?

            state['otherInfo.allowEDCtoModify'] = { state: 'editable' };
            state['otherInfo.allowLSEtoModify'] = { state: 'editable' };
            state['otherInfo.holdScheduling'] = { state: 'hidden' };
            state['otherInfo.holdSettlements'] = { state: 'hidden' };
            state['otherInfo.comment'] = { state: 'hidden' };

            state['capacitySection'] = { state: 'editable' };
            state['comments'] = { state: 'editable' };

            break;
        }
        case PjmRegistrationProgram['Emergency Energy Only']: {
            // Dates editable: Effective -> Today + 2 days (12/06/2025); Termination -> 12/06/2026
            if (!isSaved) {
                const { startDate, endDate } = getDefaultRegistrationDates(program);

                const _startDate = form.getFieldValue(['summaryInfo', 'startDate'])
                    ? form.getFieldValue(['summaryInfo', 'startDate'])
                    : dayjs(startDate).tz(PJM_TZ);

                const _endDate = form.getFieldValue(['summaryInfo', 'endDate'])
                    ? form.getFieldValue(['summaryInfo', 'endDate'])
                    : dayjs(endDate).tz(PJM_TZ);

                form.setFieldValue(['summaryInfo', 'startDate'], _startDate);
                form.setFieldValue(['summaryInfo', 'endDate'], _endDate);

                form.setFieldValue(['summaryInfo', 'testRequired'], false);
                form.setFieldValue(['summaryInfo', 'completed'], false);
            }

            state['summaryInfo.name'] = { state: 'editable' };
            state['summaryInfo.program'] = { state: 'editable' };
            state['summaryInfo.startDate'] = { state: 'editable' };
            state['summaryInfo.endDate'] = { state: 'editable' };
            state['summaryInfo.CSP.name'] = { state: 'disabled' };
            state['summaryInfo.CSP.accountNo'] = { state: 'hidden' };
            state['summaryInfo.EDC.name'] = { state: 'disabled' };
            state['summaryInfo.EDC.accountNo'] = { state: 'hidden' };
            state['summaryInfo.LSE.name'] = { state: 'editable' };
            state['summaryInfo.zone'] = { state: 'disabled' };
            state['summaryInfo.pricingPoint'] = { state: 'disabled' };
            state['summaryInfo.status'] = { state: 'disabled' };

            state['locationSummaryInfo.energyLossFactor'] = { state: 'disabled' };
            state['locationSummaryInfo.maximumLoadReductionCapability'] = { state: 'disabled' };

            // locationInfo - ignore for now

            state['energyInfo.strikePrice'] = { state: 'editable' };
            state['energyInfo.shutdownCosts'] = { state: 'editable' };

            state['cblMethodInfo.methodName'] = { state: 'hidden' };

            state['otherInfo.allowEDCtoModify'] = { state: 'editable' };
            state['otherInfo.allowLSEtoModify'] = { state: 'editable' };
            state['otherInfo.holdScheduling'] = { state: 'disabled' };
            state['otherInfo.holdSettlements'] = { state: 'disabled' };
            state['otherInfo.comment'] = { state: 'hidden' };

            state['energySection'] = { state: 'editable' };
            state['comments'] = { state: 'editable' };

            break;
        }
        case PjmRegistrationProgram['Price Responsive Demand']: {
            // Dates combined: Effective editable -> Today+1 day (12/05/2025); Termination -> 05/31/2026
            if (!isSaved) {
                const { startDate, endDate } = getDefaultRegistrationDates(program);

                const _startDate = form.getFieldValue(['summaryInfo', 'startDate'])
                    ? form.getFieldValue(['summaryInfo', 'startDate'])
                    : dayjs(startDate).tz(PJM_TZ);

                form.setFieldValue(['summaryInfo', 'startDate'], _startDate);
                form.setFieldValue(['summaryInfo', 'endDate'], dayjs(endDate).tz(PJM_TZ));

                form.setFieldValue(['summaryInfo', 'testRequired'], true);
                form.setFieldValue(['summaryInfo', 'completed'], false);
            }

            state['summaryInfo.name'] = { state: 'editable' };
            state['summaryInfo.program'] = { state: 'editable' };
            state['summaryInfo.startDate'] = { state: 'editable' };
            state['summaryInfo.endDate'] = { state: 'disabled' };
            state['summaryInfo.CSP.name'] = { state: 'disabled' };
            state['summaryInfo.CSP.accountNo'] = { state: 'hidden' };
            state['summaryInfo.EDC.name'] = { state: 'disabled' };
            state['summaryInfo.EDC.accountNo'] = { state: 'hidden' };
            state['summaryInfo.LSE.name'] = { state: 'editable' };
            state['summaryInfo.zone'] = { state: 'disabled' };
            state['summaryInfo.pricingPoint'] = { state: 'disabled' };
            state['summaryInfo.status'] = { state: 'disabled' };

            state['locationSummaryInfo.capacityLossFactor'] = { state: 'disabled' };
            state['locationSummaryInfo.peakLoadContribution'] = { state: 'disabled' };
            state['locationSummaryInfo.maximumLoadReductionCapability'] = { state: 'disabled' };

            state['capacityInfo.peakLoadContribution'] = { state: 'disabled' };
            state['capacityInfo.measurementMethod'] = { state: 'editable' };
            state['capacityInfo.summerManagedLoad'] = { state: 'editable' };
            state['capacityInfo.capacityLossFactor'] = { state: 'disabled' };
            state['capacityInfo.summerNominatedICAP'] = { state: 'disabled' };

            state['cblMethodInfo.methodName'] = { state: 'hidden' };

            state['priceResponsiveDemandInfo.dynamicRetailRate'] = { state: 'editable' };
            state['priceResponsiveDemandInfo.scadaAvailable'] = { state: 'editable' };

            state['otherInfo.allowEDCtoModify'] = { state: 'editable' };
            state['otherInfo.allowLSEtoModify'] = { state: 'editable' };
            state['otherInfo.holdScheduling'] = { state: 'hidden' };
            state['otherInfo.holdSettlements'] = { state: 'hidden' };
            state['otherInfo.comment'] = { state: 'hidden' };

            state['priceResponsiveDemandSection'] = { state: 'editable' };
            state['capacityPrdSection'] = { state: 'editable' };
            state['comments'] = { state: 'editable' };

            break;
        }
        case PjmRegistrationProgram['Peak Shaving Adjustment']: {
            // Dates hardcoded: Effective -> 06/01/2025; Termination -> 05/31/2026
            if (!isSaved) {
                const { startDate, endDate } = getDefaultRegistrationDates(program);

                form.setFieldValue(['summaryInfo', 'startDate'], dayjs(startDate).tz(PJM_TZ));
                form.setFieldValue(['summaryInfo', 'endDate'], dayjs(endDate).tz(PJM_TZ));

                form.setFieldValue(['summaryInfo', 'testRequired'], false);
                form.setFieldValue(['summaryInfo', 'completed'], false);
            }

            state['summaryInfo.name'] = { state: 'editable' };
            state['summaryInfo.program'] = { state: 'editable' };
            state['summaryInfo.startDate'] = { state: 'disabled' };
            state['summaryInfo.endDate'] = { state: 'disabled' };
            state['summaryInfo.CSP.name'] = { state: 'disabled' };
            state['summaryInfo.CSP.accountNo'] = { state: 'hidden' };
            state['summaryInfo.EDC.name'] = { state: 'disabled' };
            state['summaryInfo.EDC.accountNo'] = { state: 'hidden' };
            state['summaryInfo.LSE.name'] = { state: 'hidden' };
            state['summaryInfo.zone'] = { state: 'disabled' };
            state['summaryInfo.pricingPoint'] = { state: 'disabled' };
            state['summaryInfo.status'] = { state: 'disabled' };

            state['locationSummaryInfo.energyLossFactor'] = { state: 'disabled' };
            state['locationSummaryInfo.maximumLoadReductionCapability'] = { state: 'disabled' };

            state['cblMethodInfo.methodName'] = { state: 'hidden' };

            state['otherInfo.allowEDCtoModify'] = { state: 'editable' };
            state['otherInfo.allowLSEtoModify'] = { state: 'editable' };
            state['otherInfo.holdScheduling'] = { state: 'disabled' };
            state['otherInfo.holdSettlements'] = { state: 'disabled' };

            state['peakShavingProgram'] = { state: 'editable' };
            state['comments'] = { state: 'editable' };

            break;
        }
        default:
            /** when program is not selected */
            state['summaryInfo.name'] = { state: 'editable' };
            state['summaryInfo.program'] = { state: isSaved ? 'disabled' : 'editable' };
            state['summaryInfo.startDate'] = { state: isSaved ? 'disabled' : 'disabled' };
            state['summaryInfo.endDate'] = { state: isSaved ? 'disabled' : 'disabled' };
            state['summaryInfo.CSP.name'] = { state: 'disabled' };
            state['summaryInfo.CSP.accountNo'] = { state: 'hidden' };
            state['summaryInfo.EDC.name'] = { state: 'disabled' };
            state['summaryInfo.EDC.accountNo'] = { state: 'hidden' };
            state['summaryInfo.LSE.name'] = { state: 'hidden' };
            state['summaryInfo.zone'] = { state: 'disabled' };
            state['summaryInfo.pricingPoint'] = { state: 'disabled' };
            state['summaryInfo.status'] = { state: 'disabled' };

            state['otherInfo.allowEDCtoModify'] = { state: 'editable' };
            state['otherInfo.allowLSEtoModify'] = { state: 'editable' };
            state['otherInfo.holdScheduling'] = { state: 'hidden' };
            state['otherInfo.holdSettlements'] = { state: 'hidden' };
    }

    state['summaryInfo.program'] = { state: isSaved ? 'disabled' : 'editable' };

    return state;
}

function deriveFromStateForStatus(state: PjmRegistrationFormState, form: FormInstance<PjmRegistrationDto>): PjmRegistrationFormState {
    const status = form.getFieldValue(['summaryInfo', 'status']);

    switch (status) {
        case PjmRegistrationStatus.NEW:
            // do nothing - we keep state defined in the prev step: deriveFromStateForProgram
            break;
        case PjmRegistrationStatus.PENDING_PJM:
            // everything disabled
            Object.values(state).map(item => {
                if (item.state === 'editable') {
                    item.state = 'disabled';
                }
                return item;
            });
            break;
        case PjmRegistrationStatus.CONFIRMED:
        case PjmRegistrationStatus.CONFIRMED_EXTENSION:
            // most of fields are disabled, but not all!

            const isResidentialChecked = form.getFieldValue(['summaryInfo', 'residential']);

            // ? - not sure, need to confirm
            if (state['summaryInfo.LSE.name'].state === 'editable') {
                state['summaryInfo.LSE.name'].state = 'disabled';
            }

            state['otherInfo.allowEDCtoModify'] = { state: 'disabled' };
            state['otherInfo.allowLSEtoModify'] = { state: 'disabled' };
            state['otherInfo.holdScheduling'] = { state: 'disabled' };
            state['otherInfo.holdSettlements'] = { state: 'disabled' };

            state['summaryInfo.underDuplicateReview'] = { state: 'disabled' };

            state['summaryInfo.residential'] = { state: 'disabled' };
            state['summaryInfo.residentialProgramType'] = { state: isResidentialChecked ? 'disabled' : 'hidden' };
            state['summaryInfo.loadDataSample'] = { state: isResidentialChecked ? 'disabled' : 'hidden' };
            state['summaryInfo.sampleNumberParticipants'] = { state: isResidentialChecked ? 'disabled' : 'hidden' };

            state['summaryInfo.testRequired'] = { state: 'disabled' };
            state['summaryInfo.completed'] = { state: 'disabled' };

            // you cannot change dates
            state['summaryInfo.startDate'] = { state: 'disabled' };
            state['summaryInfo.endDate'] = { state: 'disabled' };

            break;
        case PjmRegistrationStatus.DENIED:
            // this status is probably very similar to withdrawn?!
            // do nothing - we keep state defined in the prev step: deriveFromStateForProgram
            break;
        case PjmRegistrationStatus.WITHDRAWN:
            // do nothing - we keep state defined in the prev step: deriveFromStateForProgram
            break;
        case PjmRegistrationStatus.TERMINATED:
        case PjmRegistrationStatus.TERMINATED_DUPLICATE:
            // everything disabled?
            Object.values(state).map(item => {
                if (item.state === 'editable') {
                    item.state = 'disabled';
                }
                return item;
            });
            break;
        default:
    }

    // todo: when effectiveDate is in the past - probably we need to disabled most of the fields

    return state;
}
